// extracted by mini-css-extract-plugin
export default {"tableCell":"ItemsNotFound_tableCell__u-uwm","contentBox":"ItemsNotFound_contentBox__RMNFl","searchIcon":"ItemsNotFound_searchIcon__aZ3dW"};